var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.title1)
    }
  }), _c('div', {
    staticClass: "paragraph-1 spacing",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.text1)
    }
  }), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.title2)
    }
  }), _c('div', {
    staticClass: "paragraph-1 spacing",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.text2)
    }
  }), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('seu-button', {
    staticClass: "spacing",
    attrs: {
      "button-link": _vm.popup.sections.main.fields.value.buttonLink1,
      "label": _vm.popup.sections.main.fields.value.buttonLabel1
    }
  })], 1), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.title3)
    }
  }), _c('div', {
    staticClass: "paragraph-1 spacing",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.text3)
    }
  }), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('seu-button', {
    staticClass: "spacing",
    attrs: {
      "target": "_blank",
      "button-link": _vm.popup.sections.main.fields.value.buttonLink2,
      "label": _vm.popup.sections.main.fields.value.buttonLabel2
    }
  })], 1), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.title4)
    }
  }), _c('div', {
    staticClass: "paragraph-1 spacing",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.text4)
    }
  }), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('seu-button', {
    staticClass: "spacing",
    attrs: {
      "target": "_blank",
      "button-link": _vm.popup.sections.main.fields.value.buttonLink3,
      "label": _vm.popup.sections.main.fields.value.buttonLabel3
    }
  })], 1), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.title5)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.text5)
    }
  }), _c('div', {
    staticClass: "contact-member"
  }, [_c('div', {
    staticClass: "lead-1",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.memberName)
    }
  }), _c('a', {
    staticClass: "paragraph-1",
    attrs: {
      "href": "mailto:marco.quinter@seu.ch"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.memberEmail)
    }
  }), _c('a', {
    staticClass: "paragraph-1-link",
    attrs: {
      "href": "tel:+41 (0) 79 402 91 11"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.memberNumber)
    }
  })]), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.popup.sections.main.fields.value.text6)
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }